import { Routes } from '@angular/router';

import { Route } from './core/Routes';
import { AppRoute } from './shared/app.route.enum';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: `/${AppRoute.Dashboard}`,
    pathMatch: 'full',
  },
  Route.withBaseLayoutAndAuthentication([
    {
      path: AppRoute.Forbidden,
      loadChildren: () => import('./core/forbidden/forbidden.routes').then((routes) => routes.forbiddenRoutes),
    },
    {
      path: AppRoute.Dashboard,
      loadChildren: () => import('./dashboard/dashboard.routes').then((routes) => routes.dashboardRoutes),
    },
    {
      path: AppRoute.Podcasts,
      loadChildren: () => import('./podcasts/podcasts.routes').then((routes) => routes.podcastsRoutes),
    },
    {
      path: AppRoute.Tenants,
      loadChildren: () => import('./tenants/tenants.routes').then((routes) => routes.tenantsRoutes),
    },
    {
      path: AppRoute.Users,
      loadChildren: () => import('./users/users.routes').then((routes) => routes.usersRoutes),
    },
  ]),
  {
    path: AppRoute.Login,
    loadChildren: () => import('./login/login.routes').then((routes) => routes.loginRoutes),
  },
];
